import {useCallback} from "react";
import {call} from "redux-saga/effects";
import {useSagaCallback} from '../utils/sagas';
import {apiPost, useGetRequestData} from "./client";

export const useIgnoreReports = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, type, state) {
        yield call(apiPost, `/api/v2/moderate/ignore_reports`, {
            id,
            type,
            state,
        });
    }, []))
};

export const useApprove = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, type) {
        yield call(apiPost, `/api/v2/moderate/approve`, {
            id,
            type,
        });
    }, []))
};

export const useRemove = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, type) {
        yield call(apiPost, `/api/v2/moderate/remove`, {
            id,
            type,
        });
    }, []))
};

export const useLock = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, state) {
        yield call(apiPost, `/api/v2/moderate/lock`, {
            id,
            state,
        });
    }, []))
};

export const useStickied = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, type, state) {
        yield call(apiPost, `/api/v2/moderate/sticky`, {
            id,
            type,
            state,
        });
    }, []))
};

export const useModDistinguish = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, type, state) {
        yield call(apiPost, `/api/v2/moderate/distinguish`, {
            id,
            type,
            state
        });
    }, []))
};

export const useSetSuggestedSort = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, sort) {
        yield call(apiPost, `/api/v2/moderate/sort`, {
            id,
            sort
        });
    }, []))
};

export const useAddNote = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, community, note) {
        yield call(apiPost, `/api/v2/moderate/create_note`, {
            username,
            community,
            note
        });
    }, []))
};

export const useBan = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, community, reason, days, ip, nuke) {
        yield call(apiPost, `/api/v2/moderate/ban`, {
            username,
            community,
            reason,
            days,
            ip,
            nuke
        });
    }, []))
};

export const useUnban = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, community) {
        yield call(apiPost, `/api/v2/moderate/unban`, {
            username,
            community
        });
    }, []))
};

export const useAddModerator = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (data) {
        yield call(apiPost, `/api/v2/community/add_moderator.json`, data);
    }, []))
};

export const useUpdateModerator = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (data) {
        yield call(apiPost, `/api/v2/community/update_moderator.json`, data);
    }, []))
};

export const useRemoveModerator = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (community, author) {
        yield call(apiPost, `/api/v2/community/remove_moderator.json`, {
            community,
            author
        });
    }, []))
};

export const useModMessage = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, community, subject, content) {
        yield call(apiPost, `/api/v2/moderate/mod_message`, {
            username,
            community,
            subject,
            content
        });
    }, []))
};

export const useSaveRules = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (rules, community) {
        yield call(apiPost, `/api/v2/community/rules.json`, {
            rules,
            community
        });
    }, []))
};

export const useBanStatus = (feedbackCh, username, community) =>
    useGetRequestData(feedbackCh, `/api/v2/moderate/get_ban?username=${username}&community=${community}`)?.users[0];

export const useNotes = (feedbackCh, username, community) =>
    useGetRequestData(feedbackCh, `/api/v2/moderate/get_notes?username=${username}&community=${community}`)?.notes;

export const useReports = (feedbackCh, id, type) =>
    useGetRequestData(feedbackCh, `/api/v2/moderate/get_reports?id=${id}&type=${type}`)?.reports;

export const useBans = (feedbackCh, community, page, time) =>
    useGetRequestData(feedbackCh, `/api/v2/community/bans.json?community=${community}&page=${page}&time=${time}`)?.users;

export const useFullModeratorsList = (feedbackCh, community, time) =>
    useGetRequestData(feedbackCh, `/api/v2/community/list_moderators.json?community=${community}&time=${time}`);
